module.exports = __webpack_public_path__ + "assets/img/price.d47585c8.svg";